import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';

import { LoggerScope } from './types';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  error(message: string, extra?: LoggerScope): void {
    this.captureMessage(message, 'error', extra);
  }

  info(message: string, extra?: LoggerScope): void {
    this.captureMessage(message, 'info', extra);
  }

  warn(message: string, extra?: LoggerScope): void {
    this.captureMessage(message, 'warning', extra);
  }

  private captureMessage(message: string, level: Sentry.SeverityLevel, extra?: LoggerScope): void {
    Sentry.withScope((scope) => {
      if (extra) {
        if (extra.context) {
          Object.entries(extra.context).forEach(([key, value]) => {
            scope.setContext(key, value);
          });
        }

        if (extra.tags) {
          Object.entries(extra.tags).forEach(([key, value]) => {
            scope.setTag(key, value);
          });
        }

        if (extra.user) {
          scope.setUser(extra.user);
        }
      }

      Sentry.captureMessage(message, level);
    });
  }
}
